export default {"src":"/_next/static/media/gn-white.ce8e776d.svg","height":195,"width":488};